/**
 * Toggles whether the password is hidden or shown. Additionally, it ensures that
 * any Accessibility related labelling and announcements are updated.
 * */
import { loginWithPasskey } from './passkey';

const toggleShowHidePassword = (toggleButton: HTMLButtonElement, passwordField: HTMLInputElement) => {
    const showHidePasswordAnnouncement = document.getElementById('showhide-password-announcement')!;
    // Notifies the current state of the password field to the screen reader
    const ariaLabelPasswordHidden = showHidePasswordAnnouncement.dataset.textHiddenTranslated!;
    const ariaLabelPasswordVisible = showHidePasswordAnnouncement.dataset.textVisibleTranslated!;
    // Visual label on the button
    const labelHidePassword = toggleButton.dataset.textHideTranslated!;
    const labelShowPassword = toggleButton.dataset.textShowTranslated!;
    // Aria label on the button. This text is more descriptive than label(Hide|Show)Password
    // to give screen readers more context
    const ariaLabelShowPassword = toggleButton.dataset.textScreenreaderShowTranslated!;
    const ariaLabelHidePassword = toggleButton.dataset.textScreenreaderHideTranslated!;

    const isPasswordHidden = toggleButton.getAttribute('aria-checked') === 'false';
    if (isPasswordHidden) {
        toggleButton.innerText = labelHidePassword;
        passwordField.type = 'text';
        toggleButton.setAttribute('aria-checked', 'true');
        toggleButton.setAttribute('aria-label', ariaLabelHidePassword);
        // Changing the password visibility state last ensures the screen reader reads this text
        showHidePasswordAnnouncement.innerText = ariaLabelPasswordVisible;
    } else {
        toggleButton.innerText = labelShowPassword;
        passwordField.type = 'password';
        toggleButton.setAttribute('aria-checked', 'false');
        toggleButton.setAttribute('aria-label', ariaLabelShowPassword);
        // Changing the password visibility state last ensures the screen reader reads this text
        showHidePasswordAnnouncement.innerText = ariaLabelPasswordHidden;
    }
};

const handleLoginForm = () => {
    // Passkey button press?
    const loginButton = document.getElementById('passkey-signin-button');
    if (loginButton) {
        loginButton.addEventListener('click', async (event) => {
            event.preventDefault(); // Prevent the default form submission
            const requestCredentialOptionsJSON = JSON.parse(loginButton.dataset.publicKeyCredentialRequestOptions!);
            await loginWithPasskey(requestCredentialOptionsJSON, 'passkey-signin-input');
        });
    }

    const showHidePassword = document.getElementById('showhide-password');
    const passwordField: HTMLInputElement | null = document.getElementById('password') as HTMLInputElement;

    if (showHidePassword && passwordField) {
        showHidePassword.addEventListener('click', (event) => {
            const target = event.target as HTMLButtonElement;
            toggleShowHidePassword(target, passwordField);
        });
        const loginForm = document.querySelector('form[name="f"]')!;

        loginForm.addEventListener('submit', () => {
            if (passwordField.type !== 'password') {
                // Force password field to be of type password before submitting,
                // this should prevent browsers Autocomplete functionality from remembering
                // the password, because it thought the input was of type text
                passwordField.type = 'password';
            }
        });
    }
    // Conditional UI for passkey login
    // Check if the browser supports WebAuthn conditionall ui
    if (window.PublicKeyCredential && 'isConditionalMediationAvailable' in PublicKeyCredential) {
        (async () => {
            const isCMA = await PublicKeyCredential.isConditionalMediationAvailable();
            if (isCMA) {
                const publicKeyCredentialRequestOptions = loginButton!.dataset.publicKeyCredentialRequestOptions!;
                const requestCredentialOptionsJSON = JSON.parse(publicKeyCredentialRequestOptions);
                loginWithPasskey(requestCredentialOptionsJSON, 'passkey-signin-input', true);
            }
        })();
    }
};

$(document).ready(() => {
    const body = $('body');
    const page = body.attr('id');

    if (page !== 'feide:login') {
        return;
    }

    handleLoginForm();
});
